import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b97a95b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6b97a95b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97a95b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b97a95b')) {
      api.createRecord('6b97a95b', component.options)
    } else {
      api.reload('6b97a95b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b97a95b&scoped=true&", function () {
      api.rerender('6b97a95b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/internalLogin/index.vue"
export default component.exports